module.exports = __webpack_public_path__ + "img/stake-hover.45ecba64.svg";